<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                    <el-form-item label="药店名称">
                        <el-input class="width_220"
                                  @change="getTableData()"
                                  v-model="searchForm.user_id"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getTableData()"
                                   type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {formatTime} from "../global/utils";
    import {mapState} from "vuex"

    export default {
        name: "ULogView",
        data() {
            return {
                text: '',
                searchForm: {
                    entry_point: '',
                    user_id: '',
                    action: '',
                    item_id: '',
                    date: [],
                },
                tableData: [],
                columnData: [
                    {label: '名称', prop: 'action'},
                    {label: '操作时间', prop: 'action_time'},
                    {label: '入口', prop: 'entry_point'},
                    {label: '用户ID', prop: 'user_id'},
                    {label: '对象ID', prop: 'item_id'},
                    {label: '对象类型', prop: 'item_type'},
                    {label: '备注', prop: 'remark'},
                ],
                total: 0,
                currentPage: 1,
                pageSize: 50,

                action_list: []
            }
        },
        computed: {
            ...mapState("comInformationData", {
                // entry_point_list: 'entry_point_list',
                // action_list: 'action_list',
                entry_point_action: 'entry_point_action',
            })
        },
        mounted() {
            this.getFirstDate()
        },
        methods: {
            changeEntry(val) {
                console.log(val, '130');
                if (val) {
                    this.entry_point_action.forEach(e => {
                        if (e.name === val) {
                            this.action_list = e.action_list
                        }
                    });
                } else {
                    this.action_list = [];
                }
                this.searchForm.action = ''; // 切换入口则操作类型清空

                this.getTableData()
            },

            getFirstDate() {
                let e_t = new Date();
                let f = e_t.getTime() - 1000 * 60 * 60 * 24;
                let f_t = new Date(f);
                let first_time = formatTime(f_t).time3;
                let end_time = formatTime(e_t).time3;
                this.searchForm.date = [first_time, end_time];
                console.log(this.searchForm.date, '91');
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    start_action_time: this.searchForm.date[0],
                    end_action_time: this.searchForm.date[1],
                    entry_point: this.searchForm.entry_point,
                    user_id: this.searchForm.user_id,
                    action: this.searchForm.action,
                    item_id: this.searchForm.item_id,
                };
                this.httpGet('/action_log/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;

                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>